import React from "react";
import { Avatar, Box } from "@mui/material";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

/**
 * Avatar and user name for sidebar, using profile info from Redux.
 * Shows initials in Avatar and full name next to it when sidebar expanded.
 */
export default function UserProfileSidebarAvatar({ collapsed }) {
  const { profile } = useSelector((state) => state.profile);

  let initials = "A";
  if (profile) {
    const { first_name = "", last_name = "" } = profile;
    initials =
      `${first_name[0] || ""}${last_name[0] || ""}`.toUpperCase() || "A";
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        mb: 1,
        width: "100%",
      }}
    >
      <Avatar
        sx={{
          bgcolor: "#a20023",
          width: collapsed ? 32 : 40,
          height: collapsed ? 32 : 40,
          fontWeight: 700,
          fontSize: collapsed ? 16 : 20,
          mb: 1,
          mt: 0.5,
          transition: "all 0.3s",
        }}
      >
        {initials}
      </Avatar>
    </Box>
  );
}

UserProfileSidebarAvatar.propTypes = {
  collapsed: PropTypes.bool,
};
